var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center h-100vh"},[_c('img',{staticClass:"pic-404__parent",attrs:{"src":require("@/assets/404_images/404.png"),"alt":"404"}})])
}]

export { render, staticRenderFns }